import { FunctionComponent, useMemo } from "react";
import { observer } from "mobx-react-lite";

import { DisclaimerItemDto } from "../../../../../@api";

import { translationKeys } from "../../../../models/app-translation-keys";
import { useDisclaimerService } from "../../../../services/ServiceHooks/disclaimerHook";
import { DisclaimersForm } from "./DisclaimersForm";
import { useDisclaimersTabState } from "./useDisclaimersTabState";

const DisclaimersTabRaw: FunctionComponent = () => {
  const disclaimerService = useDisclaimerService();

  const disclaimersTranslationKeys = translationKeys.adminArea.disclaimers;

  const stateOptions = useMemo(
    () => ({
      commonTranslation: disclaimersTranslationKeys.common,
      bingOptions: {
        disclaimerType: "bing" as const,
        loadDisclaimerTexts: () => disclaimerService.getDisclaimerTexts("bing"),
        translation: disclaimersTranslationKeys.bing,
        resetMode: "original" as const,
      },
      imageGenOptions: {
        disclaimerType: "imagegen" as const,
        loadDisclaimerTexts: () => disclaimerService.getDisclaimerTexts("imagegen"),
        translation: disclaimersTranslationKeys.imagegen,
        resetMode: "original" as const,
      },
      saveDisclaimerTexts: (disclaimerItems: Array<DisclaimerItemDto>) =>
        disclaimerService.putDisclaimerTextsBulk(disclaimerItems),
    }),
    [disclaimerService, disclaimersTranslationKeys],
  );

  const { loading, saving, bingTexts, imageGenTexts, hasChanges, onChangeBing, onChangeImageGen, onSave, onReset } =
    useDisclaimersTabState(stateOptions);

  return (
    <DisclaimersForm
      loading={loading}
      saving={saving}
      bingTexts={bingTexts}
      imageGenTexts={imageGenTexts}
      commonTranslationKeys={disclaimersTranslationKeys.common}
      bingTranslationKeys={disclaimersTranslationKeys.bing}
      imageGenTranslationKeys={disclaimersTranslationKeys.imagegen}
      hasChanges={hasChanges}
      onChangeBing={onChangeBing}
      onChangeImageGen={onChangeImageGen}
      onSave={onSave}
      onReset={onReset}
    />
  );
};

export const DisclaimersTab = observer(DisclaimersTabRaw);
